module.exports = __webpack_public_path__ + "static/media/search-input.95351fb5.svg";